import { Share2, Search } from 'lucide-react';

export type Channel = 'social' | 'search';

const CHANNELS: { key: Channel; label: string; icon: typeof Share2 }[] = [
  { key: 'social', label: 'Social', icon: Share2 },
  { key: 'search', label: 'Search', icon: Search },
];

const COLOR_MAP: Record<string, { border: string; bg: string; text: string }> = {
  blue:   { border: 'border-blue-800',   bg: 'bg-blue-50',   text: 'text-blue-800'   },
  purple: { border: 'border-purple-600', bg: 'bg-purple-50', text: 'text-purple-600' },
  green:  { border: 'border-green-700',  bg: 'bg-green-50',  text: 'text-green-700'  },
  orange: { border: 'border-orange-700', bg: 'bg-orange-50', text: 'text-orange-700' },
};

export function ChannelToggle({
  value,
  onChange,
  color = 'blue',
}: {
  value: Channel;
  onChange: (channel: Channel) => void;
  color?: 'blue' | 'purple' | 'green' | 'orange';
}) {
  function handleChange(key: Channel) {
    onChange(key);
    window.scrollTo(0, 0);
  }

  const c = COLOR_MAP[color];

  return (
    <div className="flex items-center justify-center gap-2" role="tablist">
      {CHANNELS.map(({ key, label, icon: Icon }) => {
        const isActive = value === key;
        return (
          <button
            key={key}
            role="tab"
            aria-selected={isActive}
            onClick={() => handleChange(key)}
            className={`flex-1 flex items-center justify-center gap-2 px-6 py-2.5 text-sm font-medium rounded-lg border transition-all ${
              isActive
                ? `${c.border} ${c.bg} ${c.text}`
                : 'border-slate-200 bg-white text-slate-400 hover:text-slate-600 hover:border-slate-300'
            }`}
          >
            <Icon className="w-4 h-4" strokeWidth={2} />
            {label}
          </button>
        );
      })}
    </div>
  );
}
